import { Button, Checkbox, Label, Select, Modal, TextInput } from 'flowbite-react';
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PublicService from '../../../services/PublicService';
import Helpers from '../../../utils/Helpers';
import ButtonLoading from '../../../components/ButtonLoading';
import { BiArrowBack } from 'react-icons/bi';
import helpers from '../../../utils/Helpers';
import { CGUTextComponent } from './CGUTextComponent';
import { StorageContext } from '../../../storage/StorageContext';
import { setVisitorInfos, updateCGUAccept } from '../../../storage/Actions';

const PaywayChooseModal = ({
  opened = null,
  onAskClose = null,
  mandatoryInfos = null,
  legacy= false
}) => {
  const { t } = useTranslation('paywayChooseModal');
  const { storage, dispatch } = useContext(StorageContext);
  const phoneRef = useRef(null);
  const fullNameRef = useRef(null);
  const emailRef = useRef(null);
  const [step, setStep] = useState('');
  const [loading, setLoading] = useState(false);
  const [conditionsAccepted, setConditionsAccepted] = useState(storage.cgu_accepted_at === (new Date()).toLocaleDateString('en-CA'));

  const mandatoryFields = {
    'wave-pay': ['fullName'],
    'card-pay': ['fullName', 'email'],
    'others': ['fullName'],
    ...(mandatoryInfos || {})
  };

  const getWavePayLink = () => {
    const phone = phoneRef.current.value;
    const fullName = fullNameRef.current.value;
    const email = emailRef.current.value;

    if (!phone || isNaN(phone) || phone.length < 10) {
      helpers.alert.error(t('Entrez un numéro de télephone correct'));
      return;
    }

    setLoading(true);

    const func = legacy
      ? PublicService.getPreparedPay(opened?.sess, opened?.candidate.id, opened?.qty, { way: 'wave', phone, fullName, email })
      : PublicService.sendPostQuery(
          opened?.getLinkUrl,
            {
              ...(opened?.getLinkData || {}),
              is_wave: true,
              pay_phone: phone,
              fullName,
              email
            }
        );

      func.then(response => {
        window.onblur = () => onAskClose({ token: response.token, is_wave: true, opened, by: 'wave-pay' });
        window.location.href = response.invoice_url;
      })
      .catch(err => {
        Helpers.alert.error(err.message);
        setLoading(false);
      });
  };

  const goToPay = (way) => {
    const mandatories = mandatoryFields[way];

    if (mandatories.includes('email') && !emailRef.current.value) {
      Helpers.alert.error(t('Entrez votre nom et votre email.'));
      return;
    }
    if (mandatories.includes('fullName') && !fullNameRef.current.value) {
      Helpers.alert.error(t('Entrez votre nom et votre email.'));
      return;
    }
    if (emailRef.current.value && !Helpers.isEmail(emailRef.current.value)) {
      helpers.alert.error(t('Adresse e-mail incorrecte.'));
      return;
    }

    switch (way) {
      case 'wave-pay':
        setStep('wave-pay');
        break;
      
      case 'card-pay':
      case 'others':
        onAskClose({
          ...opened,
          by: way,
          params: {
            scope: way === 'card-pay' ? 'international' : undefined,
            fullName: fullNameRef.current.value,
            email: emailRef.current.value
          }
        });
        break;
    }

    dispatch(
      setVisitorInfos({
        fullName: fullNameRef.current.value,
        email: emailRef.current.value
      })
    );
  };

  useEffect(() => {
    !opened && setStep('');
    setLoading(false);
  }, [opened]);

  return (
    <Modal show={!!opened} size='md' className='z-[100]'>
      <Modal.Body className='relative'>
        {/* Close button */}
        <button onClick={() => onAskClose(null)} className='w-6 h-6 rounded-full border bg-white absolute outline-none right-3 top-3'>&times;</button>
        
        {/* Title and description */}
        <h1 className='text-3xl text-gray-700 font-bold'>{t('Payez avec')}</h1>
        <p className='text-sm text-gray-400 font-light'>{t('Par quel moyen de paiement voulez vous effectuer le paiement')}</p>

        {/* CGU */}
        {!conditionsAccepted ? (
          <>
            <div className="w-full mt-5">
              <Select
                onChange={evt => {
                  document
                    .getElementById('chz_CGUS')
                    .scroll({
                      top: document.getElementById(`about_${evt.target.value}`).offsetTop - 180,
                      behavior: 'smooth'
                    });
                }}
                className="outline-none"
                defaultValue=""
              >
                <option value="" disabled>Conditions d'utilisation</option>
                <option value="chargebacks">Clause sur chargeback</option>
                <option value="doubledebit">Cas de double facturation</option>
                <option value="cancels">Annulation de service</option>
                <option value="service">Fourniture de service</option>
              </Select>
            </div>
            <div id="chz_CGUS" className="w-full max-h-72 overflow-auto mt-2 mb-5 p-3 bg-neutral-50 rounded-md border border-neutral-200 scroll-smooth">
              <CGUTextComponent />
            </div>
          </>
        ) : null}

        {/* Terms conditions acceptation */}
        <div className='mt-4 flex items-center bg-orange-100 p-2 rounded-lg'>
          <Checkbox
            id="accept"
            onChange={evt => {
              setConditionsAccepted(evt.target.checked);
              dispatch(updateCGUAccept(evt.target.checked ? (new Date()).toLocaleDateString('en-CA') : ''));
            }}
            checked={conditionsAccepted}
          />
          <Label htmlFor="accept" className="ml-3">
            {t("J'ai lu et j'accepte les termes et conditions d'utilisation de Chooz.")}
          </Label>
        </div>

        {/* name and email */}
        {conditionsAccepted ? (
          <div className="bg-neutral-50 rounded-lg p-2 border border-neutral-200 mt-3">
            <div className="">
              <TextInput
                placeholder={t('Nom et Prénons')}
                className="w-full"
                ref={fullNameRef}
                defaultValue={storage.visitor?.fullName || ''}
                disabled={step !== ''}
              />
            </div>
            <div className='mt-2'>
              <TextInput
                placeholder={t('E-mail')}
                className='w-full'
                type="email"
                ref={emailRef}
                defaultValue={storage.visitor?.email || ''}
                disabled={step !== ''}
              />
            </div>
          </div>
        ) : null}

        {/* Steps */}
        {conditionsAccepted ? (  
          <div className={`mt-3`}>
            {step === ''
              ? (
                <>
                <div className={`opacity-${fullNameRef?.current?.value ? '100' : '25'} grid grid-cols-3 gap-5`}>
                  <button type="button" onClick={() => goToPay('wave-pay')} className='text-center cursor-pointer bg-transparent border-0 p-0'>
                    <div className='rounded-lg overflow-hidden'>
                      <img src='/assets/images/wave-logo.png' className='w-full' alt='Wave' />
                    </div>
                    <span className='w-full text-base font-bold text-gray-700 mt-4 block'>{t('Wave')}</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => goToPay('card-pay')}
                    className='text-center cursor-pointer bg-transparent border-0 p-0'
                  >
                    <div className='rounded-lg overflow-hidden'>
                      <img src='/assets/images/card-logos.png' className='w-full' alt='Carte bancaire' />
                    </div>
                    <span className='w-full text-base font-bold text-gray-700 mt-4 block'>{t('Carte Bancaire')}</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => goToPay('others')}
                    className='text-center cursor-pointer bg-transparent border-0 p-0'
                  >
                    <div className='rounded-lg overflow-hidden'>
                      <img src='/assets/images/all-pay-logo.png' className='w-full' alt='Autres moyens de paiement' />
                    </div>
                    <span className='w-full text-base font-bold text-gray-700 mt-4 block'>{t('Autres')}</span>
                  </button>
                </div>
                </>
                )
              : null}
            {step === 'wave-pay'
              ? (
                <div className='bg-neutral-100 p-3 rounded-lg'>
                  <div className='rounded-lg overflow-hidden w-20 mx-auto'>
                    <img src='/assets/images/wave-logo.png' className='w-full' alt='' />
                  </div>
                  <div className='mt-4'>
                    <TextInput
                      placeholder={t('Numéro de téléphone')}
                      className='w-full'
                      ref={phoneRef}
                    />
                  </div>
                  <div className='flex mt-4 gap-2'>
                    <Button onClick={() => setStep('')} color='gray' className='h-11'>
                      <BiArrowBack size={18} />
                    </Button>
                    <ButtonLoading
                      className='bg-orange-500 hover:!bg-orange-600 grow h-11'
                      isProcessing={loading}
                      onClick={() => getWavePayLink()}
                    >
                      {t('Payer')}
                    </ButtonLoading>
                  </div>
                </div>
                )
              : null}
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  )
};

export default PaywayChooseModal;
